import './AboutUs.scss';

export const AboutUs = () => {
  return (
    <div className='container'>
      <div className='about mx-auto'>
        <h1 className='mb-4'>About Us</h1>
        <p className='mb-4'>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec aliquet
          dolor libero, eget venenatis mauris finibus dictum. Vestibulum quis
          elit eget neque porttitor congue non sit amet dolor. Proin pretium
          purus a lorem ornare{' '}
        </p>
        <p>
          sed lobortis pulvinar. Integer laoreet mi id eros porta euismod.
          Suspendisse potenti. Nulla eros mauris, convallis et sem tempus,
          viverra hendrerit sapien
        </p>
        <p>
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptatum
          doloribus iure vel, quia perferendis id, voluptas nisi laborum officia
          exercitationem recusandae commodi dignissimos maxime! Commodi,
          nesciunt sunt in veritatis numquam exercitationem esse. Dicta
          veritatis id possimus deleniti, molestias perspiciatis vero beatae
          eligendi doloribus tenetur excepturi quidem! Dicta cupiditate
          excepturi non id neque aspernatur alias hic. Quis facere pariatur quod
          nesciunt. Cumque ut iure, totam rerum eos obcaecati laborum assumenda
          id alias consequatur dolore ad commodi neque, deleniti quasi adipisci,
          impedit similique nostrum sint error quas nesciunt inventore quam.
          Corrupti totam architecto nulla quo nesciunt dicta sunt qui reiciendis
          obcaecati voluptatibus!
        </p>
      </div>
    </div>
  );
};
